import React from 'react';
import { Link } from 'react-router-dom';

export const NotFound = () => (
  <div className="flex items-center justify-center w-full h-full mt-6">
    <div className="px-10 py-16 border border-gray-200 rounded-md shadow-lg bg-gray-50">
      <h1 className="mb-3 text-xl font-bold">Not Found</h1>
      <p>
				This page doesn&apos;t exist. Check the address bar in your browser or&nbsp;
        <Link className="font-semibold text-blue-800 underline" to="/login">
					click here to go to the home page.
        </Link>
      </p>
    </div>
  </div>
);
